"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _Label = _interopRequireWildcard(require("./Label.styles"));

var propTypes = {
  /** If "optional" text should be displayed beside the label  */
  hasOptionalLabel: _propTypes["default"].bool.isRequired,

  /** If "require" text should be displayed beside the label */
  hasRequiredLabel: _propTypes["default"].bool.isRequired,

  /** Help indicator */
  help: _propTypes["default"].node,

  /** id for the element */
  id: _propTypes["default"].string,

  /** Should label and children be inline or not */
  isInline: _propTypes["default"].bool.isRequired,

  /** Should label be hidden */
  isVisuallyHidden: _propTypes["default"].bool.isRequired,

  /** Label text of the input field */
  label: _propTypes["default"].node.isRequired,

  /** Set if FormElement contains multiple children to render a legend element instead of label */
  hasFieldSet: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func
};
var defaultProps = {
  help: null,
  id: null,
  onClick: function onClick() {}
};

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "Label___StyledDiv",
  componentId: "f770ng-0"
})(["", ""], _Label["default"]);

var _StyledSpan = (0, _styledComponents["default"])("span").withConfig({
  displayName: "Label___StyledSpan",
  componentId: "f770ng-1"
})(["", ""], _Label.ruleStyles);

var Label = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var hasOptionalLabel = props.hasOptionalLabel,
      hasRequiredLabel = props.hasRequiredLabel,
      help = props.help,
      id = props.id,
      hasFieldSet = props.hasFieldSet,
      label = props.label,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["hasOptionalLabel", "hasRequiredLabel", "help", "id", "hasFieldSet", "label"]);
  var I18n = (0, _useI18n["default"])();
  var labelProps = hasFieldSet ? {
    as: "legend"
  } : {
    as: "label",
    htmlFor: id,
    ref: ref
  };
  return /*#__PURE__*/_react["default"].createElement(_StyledDiv, (0, _extends2["default"])({
    "data-pka-anchor": "form-element.label"
  }, labelProps, moreProps), label, hasOptionalLabel || hasRequiredLabel ? /*#__PURE__*/_react["default"].createElement(_StyledSpan, null, " ", hasRequiredLabel ? I18n.t("formElement.required") : null, hasOptionalLabel ? I18n.t("formElement.optional") : null) : null, help);
});

Label.displayName = "FormElement.Label";
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
var _default = Label;
exports["default"] = _default;
//# sourceMappingURL=Label.js.map